import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { OfferAndAdvertisement, OnClickAction } from 'src/data/mygolf.data';
import * as moment from 'moment';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';
import { encodeSpaces, ensureHttpPrefix } from 'src/providers/common-service';
import { Router } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';

@Component({
  selector: 'app-promo-ads-details',
  templateUrl: './promo-ads-details.component.html',
  styleUrls: ['./promo-ads-details.component.scss'],
})
export class PromoAdsDetailsComponent implements OnInit {

  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };
  @Input() promoAds: OfferAndAdvertisement;
  slideOpts: any;
  constructor(
    private modalCtrl: ModalController,
    private mg2uUtil: mygolfUtils,
    private router: Router,
    private platform: Platform,
    private iab: InAppBrowser
  ) { 
    
    this.slideOpts = {
      initialSlide: 0,
      slidesPerView: !this.isMobileLayout() ? 2.4 : this.isMobileLayout() ? 1.1 : 4,
      speed: 400,
      spaceBetween: 15,
      responsiveClass: true,
      // scrollbar:{
      //   el:'.swiper-scrollbar',
      //   draggable:true,
      // }
    };

  }

  ngOnInit() {
    // console.log('promo ads details',this.promoAds);
  }

  backRouting() {
    this.modalCtrl.dismiss();
  }

  getPromoAdsImage(imageUrl: string) {
    // console.debug("get promoAds image", imageUrl);
    return encodeSpaces(imageUrl);
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  getPromoAdsOwnerDetails(attribute: string) {
    if(!this.promoAds) return;
    switch(attribute) {
      case 'name':
        if(this.promoAds?.club) return this.promoAds?.club?.name;
        else if(this.promoAds?.partner) return this.promoAds?.partner?.name;
        else return '';
      case 'country':
        if(this.promoAds?.club) return this.promoAds?.club?.countryName;
        else if(this.promoAds?.partner) return this.promoAds?.partner?.country?.name;
        else return '';
    }
  }

  getPromoAdsDetails(attribute: string) {
    if(!this.promoAds) return;
    switch(attribute) {
      case 'date':
        if(!this.promoAds?.startDate) return '-';
        return moment(this.promoAds?.startDate,"YYYY-MM-DD").format('dddd, DD MMM YYYY');
      case 'time':
        if(!this.promoAds?.startTime) return '-';
        return moment(this.promoAds?.startTime,"HH:mm:ss").format('hh:mm a')
    }
  }

  getPromoAdsOwnerImage() {
    // console.debug("get promoAds owner image", this.promoAds);
    if(!this.promoAds) return '/assets/image/default_club.png';
    if(this.promoAds?.club) {
      if(this.promoAds?.club?.clubLogo) return encodeSpaces(this.promoAds?.club?.clubLogo);
      else if(this.promoAds?.club?.clubImage) return encodeSpaces(this.promoAds?.club?.clubImage);
      else if(this.promoAds?.club?.clubThumbnail) return encodeSpaces(this.promoAds?.club?.clubThumbnail);
    } else if(this.promoAds?.partner) {
      if(this.promoAds?.partner?.partnerImage) return encodeSpaces(this.promoAds?.partner?.partnerImage);
      else return '/assets/image/default_club.png';
    } else return '/assets/image/default_club.png';
  }

  async onZoomImage(image: string) {
    
    const modal: any = await this.modalCtrl.create(
      {
        component: ImageZoomPage,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          image: image,
          // description: _description,
          // descTopDown: 'top'
        }
      });
    await modal.present();
  }
  
  hasPromoAdsOwner() {
    if(!this.promoAds) return;
    if(this.promoAds?.club) return true;
    else if(this.promoAds?.partner) return true;
    else return;
  }

  hasViewMore() {
    if(!this.promoAds) return;
    if(this.promoAds.onClick) {
      if(this.promoAds?.onClick?.actionType === 'None') return false;
      else return true;
    }
    else return false;
  }

  
  onClickMore() {
    // console.debug("on click promo ads ", this.promoAds)
    let _onClickAction: OnClickAction = this.promoAds?.onClick;
    let _actionValue = '';
    if(_onClickAction?.actionValue) _actionValue = _onClickAction.actionValue;
    if(_onClickAction?.actionType) {
      switch(_onClickAction.actionType) {
        case 'None':
          break;
        case 'OpenUrl':
          let _url = ensureHttpPrefix(_actionValue);
          if(this.platform.is('capacitor')) {
            this.openWithInAppBrowser(_url);
          } else {
            let win = window.open(_url, '_system');
          }
          break;
        case 'OpenPage':
          this.modalCtrl.dismiss().then(()=>{
            this.router.navigate([_actionValue]);
          })
          break;
        default:
      }
    }
  }

  
  public openWithInAppBrowser(
    url: string,
    target?: string,
  ) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe((event) => {
        let loc = event.url.toLowerCase();
      });
    } else {
      _iab.on('loadstop').subscribe((event) => {
        let loc = event.url.toLowerCase();
      });
    }
    _iab.on('exit').subscribe(
      () => {
      },
      (err) => {},
    );
  }
}